
import {supportsPassive} from './Helpers/SupportPassive.js'

export default {
    name: "ScrollContainer",
    props: {
        paddingTop: {
            type: Number,
            default: () => 0
        },
        childCount: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            scrollContainer: null,
            isNavigating: false,
            debounce: null
        }
    },
    computed:{
      containerIsWindow() {
          return this.scrollContainer === document.documentElement
      }
    },
    mounted() {
        this.scrollContainer = this.isScrollable(this.$el) ? this.$el : this.getScrollableParent(this.$el)
        const sc = this.containerIsWindow ? window : this.scrollContainer
        sc.addEventListener('scroll', this.scrollStopped, supportsPassive ? {passive: true} : {})
    },
    beforeDestroy() {
        const sc = this.containerIsWindow ? window : this.scrollContainer
        sc.removeEventListener('scroll', this.scrollStopped)
        clearTimeout(this.debounce)
    },
    methods: {
        getScrollableParent(ele) {
            return !ele || ele === document.body
                ? document.documentElement
                : this.isScrollable(ele)
                    ? ele
                    : this.getScrollableParent(ele.parentNode);
        },
        isScrollable(ele){
            const hasScrollableContent = ele.scrollHeight > ele.clientHeight;
            const hasScrollableClasses = Array.from(ele.classList).some(className => className.includes('overflow-y') && !className.includes('overflow-y-hidden'));
            const overflowYStyle = window.getComputedStyle(ele).overflowY;
            const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

            return (hasScrollableContent && !isOverflowHidden) || hasScrollableClasses;
        },
        scrollStopped() {
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                if (this.isNavigating || this.childCount === 0) {
                    return
                }
                this.$emit('top-most-index', this.getTopMostIndex())
                if (this.scrollContainer.scrollTop >= this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight - 1000) {
                    this.$emit('almost-down')
                } else if (this.scrollContainer.scrollTop <= 1000) {
                    this.$emit('almost-up')
                }
            }, 50);
        },
        getScrollPercent() {
            const sc = this.scrollContainer
            return Math.round((sc.scrollTop / (sc.scrollHeight - sc.clientHeight)) * 100);
        },
        getTopMostIndex() {
            const percent = this.getScrollPercent()
            let items = Array.from(this.$el.children)
            if (percent > 50) {
                for (let i = items.length - 1; i >= 0; i--) {
                    if ((items[i].getBoundingClientRect().top + this.scrollContainer.scrollTop) <= this.scrollContainer.scrollTop + this.paddingTop) {
                        return i
                    }
                }
            } else {
                for (let i = 0; i < items.length; i++) {
                    if ((items[i].getBoundingClientRect().bottom + this.scrollContainer.scrollTop) >= this.scrollContainer.scrollTop + this.paddingTop) {
                        return i
                    }
                }
            }
        },
        scrollToIndex(index) {
            this.isNavigating = true
            this.$helpers.eventBus.$emit('stopScrollHandle', true)
            let top = this.$el.children[index].getBoundingClientRect().top - this.scrollContainer.getBoundingClientRect().top - this.paddingTop + 2;

            if (!this.containerIsWindow) {
                top = this.scrollContainer.scrollTop + top
            }
            this.scrollContainer.scrollTo({top, behavior: 'instant'})
            setTimeout(() => {
                this.$helpers.eventBus.$emit('stopScrollHandle', false)
            }, 5)
            this.isNavigating = false
        },
        persistScroll(callback, elementsHasChanged = null) {
            return new Promise((resolve, reject) => {
                try {
                    this.$helpers.eventBus.$emit('stopScrollHandle', true)
                    const {scrollTop, scrollHeight} = this.scrollContainer
                    const diffFromEls = []
                    if (elementsHasChanged) {
                        document.querySelectorAll(elementsHasChanged)
                            .forEach(el => {
                                let {top, bottom} = el.getBoundingClientRect()
                                let topFromScroll = top + scrollTop
                                if (topFromScroll > scrollTop + this.paddingTop) {
                                    return
                                }
                                diffFromEls.push({
                                    el,
                                    height: bottom - top,
                                })
                            })
                    }
                    callback()
                    this.$nextTick(() => {
                        let scrollDiff = this.scrollContainer.scrollHeight - scrollHeight + scrollTop
                        if (elementsHasChanged) {
                            scrollDiff = scrollTop
                            diffFromEls.forEach(el => {
                                let {top: newTop, bottom: newBottom} = el.el.getBoundingClientRect()
                                const newHight = newBottom - newTop
                                scrollDiff += newHight - el.height
                            })
                        }
                        this.scrollContainer.scrollTo({top: scrollDiff, behavior: 'instant'})
                        setTimeout(() => {
                            this.$helpers.eventBus.$emit('stopScrollHandle', false)
                            resolve(true)
                        }, 5)
                    })
                } catch (e) {
                    this.$helpers.eventBus.$emit('stopScrollHandle', false)
                    reject(e)
                }
            })
        }
    }
}
